import { ErrorComponent, type ErrorComponentProps } from "@tanstack/react-router";
import { isStaleBuildError, reloadForNewBuild } from "@/lib/stale-build";

/** Route errors: a screen that failed to load because Pulse was redeployed reloads onto the new build. */
export function RouteError(props: ErrorComponentProps) {
  if (isStaleBuildError(props.error) && reloadForNewBuild()) {
    return <p className="p-6 text-sm text-muted-foreground">A new version of Pulse is available. Updating…</p>;
  }
  return <ErrorComponent {...props} />;
}
